import { Checkbox, FormControlLabel, CheckboxProps } from '@mui/material';

type DpCheckboxFormProps = CheckboxProps & {
	children?: React.ReactNode;
	label?: string;
};

export const DpCheckboxForm: React.FC<DpCheckboxFormProps> = ({ label, children, ...props }) => (
	<FormControlLabel control={<Checkbox {...props} />} label={label || children} />
);
